import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import Sidebar from './Sidebar';
import Header from './Header';

function Layout({ children }) {
  const [collapsed, setCollapsed] = useState(true);

  const toggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div className="d-flex">
      <Sidebar collapsed={collapsed} toggleSidebar={toggleSidebar} />
      <div className="flex-grow-1">
        <Header />
        <main className="bg-light" style={{ minHeight: 'calc(100vh - 56px)' }}>
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;
